import { DimensionType } from "../../types";
import { virtualConfiguration, virtualFrequency } from "./BulkExportStepper.constants";
import { IBulkExportStep } from "./BulkExportStepper.types";
import type { IDimensionDTO } from "../../api";

function isDynamicDateRange(type: DimensionType) {
  const dynamicDateRangeTypes = [
    DimensionType.DynamicDateRangeAQM,
    DimensionType.DynamicDateRangeAQMW,
    DimensionType.DynamicDateRangeAQMWD,
    DimensionType.DynamicDateRangeAnnual,
    DimensionType.DynamicDateRangeWeek,
  ];

  return dynamicDateRangeTypes.includes(type);
}

export function createSteps(dimensions?: IDimensionDTO[]): IBulkExportStep[] {
  if (!Array.isArray(dimensions) || dimensions.length === 0) {
    return [];
  }
  const resultCandidate = [...dimensions, virtualConfiguration];

  const dynamicDateRangeIndex = dimensions?.findIndex((d) => isDynamicDateRange(d.type)) ?? -1;
  if (~dynamicDateRangeIndex) {
    resultCandidate.splice(dynamicDateRangeIndex, 0, virtualFrequency);
  }
  return resultCandidate;
}